import TripTemperatureChart from "../trip/trip-temperature-chart";
import {FC} from "react";


interface TripTemperatureProps {
    tripId: string;
}


export const TemperaturesChart:FC<TripTemperatureProps> = ({tripId}) => {
    return <TripTemperatureChart tripId={tripId}/>;
}
